export const SSO_CANCEL_INVITE = 'SSO_CANCEL_INVITE'
export const SSO_DEACTIVATE = 'SSO_DEACTIVATE'
export const SSO_FORCE_PASSWORD_CHANGE = 'SSO_FORCE_PASSWORD_CHANGE'
export const SSO_LOGS = 'SSO_LOGS'
export const SSO_REMOVE_MFA = 'SSO_REMOVE_MFA'
export const SSO_RESEND_INVITE = 'SSO_RESEND_INVITE'
export const SSO_SEND_INVITE = 'SSO_SEND_INVITE'
export const SSO_SEND_PASSWORD_RESET = 'SSO_SEND_PASSWORD_RESET'
export const STAFF_MEMBER = 'STAFF_MEMBER'
export const STAFF_MEMBER_CREATE = 'STAFF_MEMBER_CREATE'
export const STAFF_MEMBER_REQUEST_ACCOUNT = 'STAFF_MEMBERS_REQUEST_ACCOUNT'
export const STAFF_MEMBER_SEND_ACCOUNT = 'STAFF_MEMBERS_SEND_ACCOUNT'
export const STAFF_MEMBER_UPDATE = 'STAFF_MEMBER_UPDATE'
export const STAFF_MEMBERS = 'STAFF_MEMBERS'
export const STAFF_MEMBERS_BULK_DEACTIVATE = 'STAFF_MEMBERS_BULK_DEACTIVATE'
export const STAFF_MEMBERS_DEACTIVATE = 'STAFF_MEMBERS_DEACTIVATE'

export default {
    SSO_CANCEL_INVITE,
    SSO_DEACTIVATE,
    SSO_FORCE_PASSWORD_CHANGE,
    SSO_LOGS,
    SSO_REMOVE_MFA,
    SSO_RESEND_INVITE,
    SSO_SEND_INVITE,
    SSO_SEND_PASSWORD_RESET,
    STAFF_MEMBER,
    STAFF_MEMBER_CREATE,
    STAFF_MEMBER_REQUEST_ACCOUNT,
    STAFF_MEMBER_SEND_ACCOUNT,
    STAFF_MEMBER_UPDATE,
    STAFF_MEMBERS,
    STAFF_MEMBERS_BULK_DEACTIVATE,
    STAFF_MEMBERS_DEACTIVATE
}
